import { bopApi } from '@/lib/api/client';

const ACCOUNT_BALANCES_PATH = 'v1/funds/frickData/accountBalances';

/** Wire shape from GET v1/funds/frickData/accountBalances */
export interface FrickAccountBalance {
  iban: string;
  currency: string;
  balance: number;
  available: number;
  refCurrency: string;
  account: string;
  customer: string;
  type: string;
  category: string;
}

export const getFrickAccountBalances = () => bopApi.get(ACCOUNT_BALANCES_PATH).json<FrickAccountBalance[]>();
